import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import FastClick from "fastclick";
import VueI18n from "vue-i18n";
import VueQriously from "vue-qriously";
import eventsService from 'libs/events'
import StorageService from 'libs/storage'
import Util from 'libs/utils'
import ApiService from '@/api'
import WechatService from 'libs/wechat'
import {
	Checkbox, 
	Dialog, 
	Toast, 
	Skeleton, 
	Lazyload, 
	Button, 
	Icon, 
	DropdownMenu, 
	DropdownItem, 
	Loading, 
	Popup,
	Field,
	Tab, 
	Tabs,
	Form,
	Picker,
	Area,
	Tag,
	DatetimePicker,
	CheckboxGroup,
	Uploader,
	Overlay,
	Search
} from 'vant';
import importDirective from "@/directive";


// import { Transfer } from 'element-ui';


// Vue.use(Loading)
Vue.use(Tag);
Vue.use(Search);
Vue.use(Overlay);
Vue.use(Uploader);
Vue.use(CheckboxGroup);
Vue.use(DatetimePicker);
Vue.use(Area);
Vue.use(Form);
Vue.use(Picker);
Vue.use(Checkbox);
Vue.use(eventsService)
Vue.use(StorageService)
Vue.use(Util)
Vue.use(ApiService)
Vue.use(WechatService)
Vue.use(VueI18n);
Vue.use(Dialog);
Vue.use(Skeleton);
Vue.use(Lazyload);
Vue.use(Button);
Vue.use(Icon);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Loading);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.prototype.$dialog = Dialog;
Vue.prototype.$toast = Toast;

Vue.use(VueQriously);

FastClick.attach(document.body);

/**
 * 注册指令
 */
importDirective(Vue);


Vue.config.productionTip = false
// px2rem 重置根目录字号 100px = 1rem
;(function(doc, win) {
  var docEl = doc.documentElement,
    recalc = function() {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return
      docEl.style.fontSize = clientWidth / 7.5 + 'px'
    }
  if (!doc.addEventListener) return
  doc.addEventListener('DOMContentLoaded', recalc, false)
  win.addEventListener('resize', recalc, false)
})(document, window)


new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})